import { TranslateService } from '@ngx-translate/core';
import { Component } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderStateDialogResult } from './order-state-dialog-result';
import { OrderState } from '../../../core/enums/order-state.enum';

@Component({
	selector: 'cfe-order-state-dialog',
	templateUrl: './order-state-dialog.component.html',
	styleUrls: ['./order-state-dialog.component.scss']
})
export class OrderStateDialogComponent {
	comment = '';
	state: OrderState;
	OrderState = OrderState;

	constructor(public translate: TranslateService, public activeModal: NgbActiveModal) {}

	close(answer: boolean, orderState?: OrderState) {
		const result = new OrderStateDialogResult();
		result.result = answer;
		if (answer) {
			result.comment = this.comment;
			result.orderState = orderState;
		}

		this.activeModal.close(result);
	}
}
